/**
 * Configuración default de campaña de módulo
 * Será mergeada con deepmerge con campaña específica
 */
export default {
  googleGTMId: "GTM-NBNM52S",
  analyticsName: "referidos",
  analyticsType: "referente",
  googleAnalyticsId: "UA-XXXXAAAA1111-1",
  modulo: "Referidos",
  cantPasos: 4,
  pasos: {
    paso1: {
      path: "/",
      component: "views/Paso1",
      paso: 1,
      analyticsName: "verificar",
      pasosSubtitle: "Verificar",
      titulo: "¡Referí y ganá increíbles premios!",
      subtitulo: "Ingresá tu documento para verificar si podés referir.",
      footer: `Dirección: Av. Córdoba 111 Piso 31, CABA <br/>
  Teléfono: 0800-333-0303 <br/>
  CUIT: 30-50000319-3 <br/><br/>
  
  <strong>Términos y condiciones de tratamiento de datos</strong><br/>
  Los datos personales aquí incluidos tienen el carácter de declaración jurada y son recogidos para ser incorporados y tratados en una base de datos, la cual se encuentra registrada en la Agencia de Acceso a la Información Pública, cuyo destinatario y titular es el Banco BBVA Argentina S.A. Cualquier falseamiento, error y/o inexactitud respecto a la información implicará la supresión de estos datos de la base de referencia y no podrán ser utilizados a futuro.<br/><br/>
  
  El usuario presta su consentimiento expreso al BBVA, para que toda la información referente a su persona, sus actividades económicas o las operaciones que haya concertado o que concierte en el futuro (en adelante y en su conjunto "la información") pueda ser transferida y cedida, aun en forma gratuita, dentro de estrictas políticas de confidencialidad y seguridad de los datos, a sus afiliadas, subsidiarias, controlantes, controladas y/o cualquier tercero. La información podrá ser utilizada para: a) La realización de segmentaciones o perfiles del Cliente, con fines comerciales a efectos de adaptar los productos o servicios a necesidades o características específicas, así como con fines de análisis de riesgos para evaluar nuevas operaciones, en ambos supuestos conservando dichas segmentaciones o perfiles en tanto y en cuanto el interviniente mantenga relación contractual con el BBVA, pudiendo oponerse en cualquier momento a dicho tratamiento; b) El envío a través de cualquier medio, por parte del BBVA de otros terceros, de ofertas comerciales, distintos tipos de informaciones o publicidades, personalizadas o no, sobre productos o servicios propios o de terceros; c) Para cualquier otra finalidad no incompatible con las especificadas anteriormente. Cuando así lo disponga, el usuario tendrá el derecho de acceder a la información y solicitar su rectificación o supresión de la base de archivo.<br/><br/>

  La Información será conservada durante el tiempo que sea necesario para cumplir con las finalidades descritas, de acuerdo con las disposiciones legales y regulatorias vigentes.<br/><br/>
  
  El BBVA informa al usuario que sus datos personales podrán ser cedidos a las autoridades competentes cuando las leyes o regulaciones de aplicación así lo establezcan.<br/><br/>
  
  En función del Estándar de la Organización para la Cooperación y Desarrollo Económicos (OCDE) para el Intercambio Automático de Información en Asuntos Fiscales y de las disposiciones de la Ley de cumplimiento fiscal de cuentas extranjeras (“Foreign Account Tax Compliance Act” - FATCA) de los Estados Unidos de América, el cliente autoriza al Banco a ceder información a autoridades de terceros países por operatorias desarrolladas en los mercados internacionales tales como Estados Unidos. Lo expuesto, ya sea de forma agregada o individual, según el caso. El titular de los datos personales tiene el derecho de acceso a los mismos en forma gratuita en intervalos no inferiores a seis meses, salvo que se acredite un interés legítimo al efecto conforme lo establecido en el artículo 14, inciso 3 de la Ley 25.326.<br/><br/>
  
  La AGENCIA DE ACCESO A LA INFORMACIÓN PUBLICA, Órgano de Control de la Ley Nº 25.326, tiene la atribución de atender las denuncias y reclamos que se interpongan con relación al incumplimiento de las normas sobre protección de datos personales.<br/><br/>
  
  <strong>Sistemas de Biometría:</strong><br/>
  En caso de que el BBVA defina el uso de dispositivos para la captura, lectura y/o procesamiento de datos –inclusive aquellos de carácter biométricos– en alguno de sus procesos operativos y/o de seguridad aplicables, el usuario autoriza al BBVA a compartir estos datos con terceros exclusivamente para el resguardo de la información capturada, la verificación de la identidad del titular de los datos y/o con los fines que el BBVA determine.<br/><br/>
  
  <strong>Sistemas de información crediticia:</strong><br/>
  Ante la solicitud de cualquier producto, el BBVA puede solicitar información a las agencias de informes comerciales a fin de evaluar la situación crediticia del usuario.<br/><br/>
  
  El usuario acepta que estará sujeto a la clasificación e inclusión en la "Central de deudores del sistema financiero", de conformidad a la normativa vigente del B.C.R.A., dado que es obligación del BBVA informar, solamente, al Banco Central de la República Argentina todos los datos que éste le requiera o que pudiera requerirle en el futuro, relacionados con sus Clientes. No será responsabilidad del BBVA la utilización de la información del usuario por parte de terceros distintos al B.C.R.A., dado que la misma no es proporcionada por el Banco.`
    },
    paso2: {
      path: "/paso2",
      component: "views/Paso2",
      paso: 2,
      analyticsName: "elegir opcion",
      pasoAnterior: "paso1",
      pasosSubtitle: "Elegí una invitación",
      titulo: "¿Qué opción querés referir?",
      subtitulo:
        "Tenés algo bueno para compartir ¡Aprovechalo! Elegí una de estas opciones <br>e invitá a más personas a ser parte de BBVA.",
      tiposReferido: {
        REFERIR_TC: {
          title: "Tarjeta de crédito",
          description:
            "Referí a tus contactos para que contraten una tarjeta, se lleven su cuenta bonificada por hasta 12 meses y un premio de 10.000 millas.",
          benefit:
            "Sumá <span data-obfuscate>20.000</span> Millas BBVA o <span data-obfuscate>$90.000</span> de saldo a favor por cada referido que contrate su tarjeta."
        },
        REFERIR_NOMINA: {
          title: "Cuenta sueldo",
          description: "Invitá a tus referidos a cobrar su sueldo en BBVA.",
          benefit:
            "Ganá <span data-obfuscate>$100.000</span> de saldo a favor cuando tu referido traiga su sueldo."
        },
        REFERIR_JUBILADO: {
          title: "Jubilación",
          description:
            "Hacé que tus referidos cobre su jubilación ANSES en BBVA.",
          benefit:
            "Ganá <span data-obfuscate>$100.000</span> de saldo a favor por cada referido que traspase sus haberes."
        }
      }
    },
    paso3: {
      path: "/paso3",
      component: "views/Paso3",
      paso: 3,
      analyticsName: "elegir premio",
      pasoAnterior: "paso2",
      pasosSubtitle: "Elegir premio",
      titulo: "¿Que premio preferís?",
      subtitulo:
        "Por cada persona que refieras podés elegir entre saldo a favor en tu tarjeta o Millas.",
      premio: {
        dinero: `Obtenelo en tu tarjeta de crédito.`,
        puntos: `Para canjes. ¡Podés volar ida y vuelta a Bariloche desde Buenos Aires!`
      },
      seleccionarTarjeta: ""
    },
    paso4: {
      path: "/paso4",
      component: "views/Paso4",
      paso: 4,
      analyticsName: "compartir invitacion",
      pasoAnterior: "paso3",
      pasosSubtitle: "Compartir invitación",
      titulo: "Enviá el enlace a tu referido",
      card: {
        title: "Copiá la invitación y enviala en un mensaje",
        description:
          "Si podemos ofrecerle una tarjeta, tu referido la puede contratar online."
      },
      notification:
        "Invitación válida por 72 horas y solo para 1 persona. Enviá una nueva invitación para referir a alguien más.",
      mensajeParaReferir: `¡Hola! 👋 Te comparto un link para que seas cliente BBVA y accedas a grandes beneficios con tu tarjeta. Este enlace es de uso único y solo tiene validez por 72 hs %shareUrl% :\n✈ Programa de *millas para viajar.*\n🛍 *Reintegros* en supermercados, combustible, indumentaria, entretenimiento.\n🎁 Tarjeta bonificada por *12 meses.*\n🤩 *¡Y mucho más!*`,
      tipoMensaje: {
        REFERIR_TC: {
          notification:
            "Invitación válida por 72 horas y solo para 1 persona. Enviá una nueva invitación para referir a alguien más.",
          mensajePorReferir: `¡Hola! 👋 Te referí para que obtengas tu tarjeta de crédito BBVA y accedas a grandes beneficios. Te comparto este enlace para que completes tus datos. Es de uso único y solo tiene validez por 72 horas. %shareUrl% :\n Contratá tu tarjeta de crédito BBVA y con tu primer consumo obtené:\n✈ Programa de *millas para viajar. ¡Tenés 10.000 Millas BBVA de regalo!\n🛍 *Reintegros* en supermercados, combustible, indumentaria, entretenimiento.\n🎁 Cuenta bonificada por hasta *12 meses.*\n🤩 *¡Y mucho más!*`
        },
        REFERIR_NOMINA: {
          notification:
            "Invitación válida por 72 horas y solo para 1 persona. Enviá una nueva invitación para referir a alguien más.",
          mensajePorReferir: `¡Hola! 👋 Te referí para que cobres tu sueldo en BBVA y accedas a grandes beneficios. Te comparto este enlace para que completes tus datos. Es de uso único y solo tiene validez por 72 horas. %shareUrl% :\n¿Qué vas a obtener si cobrás tu sueldo en BBVA?\n💰Hasta $300.000 de bienvenida si contratás una tarjeta de crédito y traes tu sueldo a BBVA.\n✈ Programa de *millas para viajar.*\n🛍 *Reintegros* en supermercados, combustible, indumentaria, entretenimiento.\n🎁 Tarjeta 100% bonificada mientras acredites tu sueldo.\n🤩 *¡Y mucho más!*`
        },
        REFERIR_JUBILADO: {
          notification:
            "Invitación válida por 72 horas y solo para 1 persona. Enviá una nueva invitación para referir a alguien más.",
          mensajePorReferir: `¡Hola! 👋 Te referí para que cobres tu jubilación en BBVA y accedas a grandes beneficios. Te comparto este enlace para que completes tus datos. Es de uso único y solo tiene validez por 72 horas. %shareUrl% :\n¿Qué vas a obtener si cobrás tu jubilación en BBVA?\n💰$160.000 de regalo de bienvenida.\n✈ Programa de *millas para viajar.*\n🛍 *Reintegros* en supermercados, combustible, indumentaria, entretenimiento.\n🎁 Tarjeta 100% bonificada mientras acredites tu jubilación.\n🤩 *¡Y mucho más!*`
        }
      }
    },
    mensaje: {
      path: "/mensaje/:mje",
      component: "views/Mensaje"
    }
  }
};

export const beneficios = {
  titulo: "Beneficios por referir en BBVA",
  items: [
    {
      label: `Por cada referido que contrate su tarjeta, vos ganás premios.`
    }
  ]
};
